import { Box, Button, Chip, Stack } from "@mui/material";
import React, { useState } from "react";
import useResponsive from "../../hooks/useResponsive";
import { useNotificationService } from "../../hooks/notification";
import { useMutation } from "@tanstack/react-query";
import { apiCreateComment, apiPostReply } from "../../api/comment";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import {
  CommentContent,
  CommentData,
  CommentReplyPropsData,
} from "../../interface/comment";
import { addCommentOrReply } from "../../utils/comment";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { newReply } from "../../utils/comment-request";

const inputSty = {
  background: "transparent",
  outline: "none",
  border: "none",
  width: "90%",
  fontWeight: 500,
  color: "#000",
  fontSize: "14px",
  "&:placeholder": {
    color: "#92A5B5",
  },
};
const CommentContainer = ({
  handleAddComment,
  data,
  newCommentContent,
  setNewCommentContent,
}: CommentContent) => {
  const { showNotification } = useNotificationService();
  const isSmall = useResponsive("down", "sm", "xl");
  const [message, setMessage] = useState("");
  const account_profile_data = useSelector(
    (state: RootState) => state.content.account_profile_data
  );

  // const mutation = useMutation({
  //   mutationFn: (field: { post_id: number; comment: string }) =>
  //     apiCreateComment(field),
  //   onSuccess: (data) => {
  //     if (data?.status === "error") {
  //       if ("details" in data) {
  //         showNotification(data?.details ?? "", "error");
  //         return;
  //       }
  //       return;
  //     }
  //     if ("data" in data) {
  //       // toggle_trigger();
  //     }
  //   },
  //   onError: (error) => {
  //     console.error("Comment process failed", error);
  //     showNotification("Comment process failed", "error");
  //   },
  // });
  // const reply_mutation = useMutation({
  //   mutationFn: (field: {
  //     post_id: number;
  //     comment: string;
  //     comment_id: number;
  //   }) => apiPostReply(field),
  //   onSuccess: (data) => {
  //     if (data?.status === "error") {
  //       if ("details" in data) {
  //         showNotification(data?.details ?? "", "error");
  //         return;
  //       }
  //       return;
  //     }
  //     if ("data" in data) {
  //     }
  //   },
  //   onError: (error) => {
  //     console.error("Reply process failed", error);
  //     showNotification("Reply process failed", "error");
  //   },
  // });
  // const handle_send = async () => {
  //   if (message.trim() === "") {
  //     showNotification("Please enter a comment", "warning");
  //     return;
  //   }
  //   if (reply_state?.reply_modal) {
  //     // a reply must be sent
  //     const new_reply = newReply(
  //       message,
  //       account_profile_data,
  //       data?.id,
  //       reply_state?.reply_data?.id
  //     );
  //     handle_add_reply(new_reply);
  //     reply_mutation.mutate({
  //       post_id: data?.id,
  //       comment: message,
  //       comment_id: reply_state?.reply_data?.id,
  //     });
  //     setMessage("");
  //     handle_close_reply("");
  //     // Call refetch_comment with a 5-second delay
  //     setTimeout(() => {
  //       refetch_comment();
  //     }, 4000);
  //     return;
  //   }

  //   handle_add_comment(message);
  //   mutation.mutate({ post_id: data?.id, comment: message });
  //   setMessage("");
  //   // Call refetch_comment with a 5-second delay
  //   setTimeout(() => {
  //     refetch_comment();
  //   }, 4000);
  // };
  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        <img
          src={account_profile_data?.image}
          alt=""
          width={28}
          height={28}
          style={{ borderRadius: "40px" }}
        />
        <Box
          sx={{
            px: 2,
            py: 1,
            borderRadius: "30px",
            backgroundColor: "#E7EBEF",
            border: "1px solid #C2CDD6",
            padding: "8px",
            width: "100%",
            display: "flex",
          }}
        >
          <input
            style={inputSty}
            value={newCommentContent}
            onChange={(e) => setNewCommentContent(e.target.value)}
            placeholder="What’s your thought"
          />
          {isSmall ? (
            <Stack direction="row" spacing={1}>
              <Button sx={{ height: "2rem" }}> Comment</Button>
            </Stack>
          ) : (
            <Button
              variant="contained"
              disabled={!newCommentContent.trim()}
              onClick={handleAddComment}
              color="primary"
              sx={{
                color: "#fafafa",
                px: 2,
                borderRadius: 6,
                height: "2rem",
              }}
            >
              Comment
            </Button>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default CommentContainer;
